import { request } from './apiClient';
import { getSessionClientId } from './authSession';

// Monta o payload de concreteira (camelCase) a partir do formulário.
// AJUSTE BACKEND AQUI: mapeamento do formulario para o contrato da API de concreteira.
export const buildConcreteiraPayload = (formData, sessionClientId) => ({
  idCliente: sessionClientId || getSessionClientId() || null,
  nomeConcreteira: formData.nomeConcreteira.trim(),
  idEmpresa: formData.idEmpresa ? Number(formData.idEmpresa) : null,
  idCidade: formData.idCidade ? Number(formData.idCidade) : null,
});

// Lista todas as concreteiras.
export const getConcreteira = async (idCliente) => {
  // AJUSTE BACKEND AQUI: endpoint de listagem de concreteiras.
  const effectiveClientId = idCliente || getSessionClientId();
  return await request(`/api/concreteira?idCliente=${effectiveClientId}`);
};

// Cria uma concreteira; retorna { response, payload }.
export const createConcreteira = async (formData, sessionClientId) => {
  const payload = buildConcreteiraPayload(formData, sessionClientId);

  // AJUSTE BACKEND AQUI: endpoint de criacao de concreteira.
  const response = await request('/api/concreteira', {
    method: 'POST',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Atualiza a concreteira por id; retorna { response, payload }.
export const updateConcreteira = async (id, formData, sessionClientId) => {
  const payload = buildConcreteiraPayload(formData, sessionClientId);
  payload.idConcreteira = id;

  // AJUSTE BACKEND AQUI: update por id da concreteira.
  const response = await request(`/api/concreteira/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Exclui a concreteira por id.
export const deleteConcreteira = async (id) => {
  // AJUSTE BACKEND AQUI: exclusao por id da concreteira.
  return await request(`/api/concreteira/${id}`, {
    method: 'DELETE'
  });
};